export interface ServiceItem {
    value: string;
    lic: string;
    parentLic: string;
    serviceCode: number;
    description: string;
}

export const HAPPINESS_SERVICES: ServiceItem[] = [
    {
        value: "Issue New Carnet",
        lic: "Issue New Carnet",
        parentLic: "ATA Carnet",
        serviceCode: 976,
        description: "~01*4$"
    },
    {
        value: "Amendment Carnet",
        lic: "Amendment Carnet",
        parentLic: "ATA Carnet",
        serviceCode: 3408,
        description: "~01*5$"
    },
    {
        value: "Additional Counterfoils",
        lic: "Additional Counterfoils",
        parentLic: "ATA Carnet",
        serviceCode: 3408,
        description: "~01*6$"
    },
    {
        value: "Substitute Carnet",
        lic: "Substitute Carnet",
        parentLic: "ATA Carnet",
        serviceCode: 2487,
        description: "~01*7$"
    },
    {
        value: "Cancellation of ATA Carnet",
        lic: "Cancellation of ATA Carnet",
        parentLic: "ATA Carnet",
        serviceCode: 4169,
        description: "~03*9$"
    },
    {
        value: "Replacement Carnet",
        lic: "Replacement Carnet",
        parentLic: "ATA Carnet",
        serviceCode: 2488,
        description: "~01*8$"
    },
    {
        value: "NOC Letter Request",
        lic: "NOC Letter Request",
        parentLic: "ATA Carnet",
        serviceCode: 2488,
        description: "~02*5$"
    },
    {
        value: "Issue New COO",
        lic: "Issue New COO",
        parentLic: "Certificate Of Origin",
        serviceCode: 822,
        description: "~0*3$"
    },
    {
        value: "Amendment",
        lic: "Amendment",
        parentLic: "Certificate Of Origin",
        serviceCode: 824,
        description: "~0*4$"
    },
    {
        value: "Issue GSP Certificate",
        lic: "Issue GSP Certificate",
        parentLic: "Certificate Of Origin",
        serviceCode: 822,
        description: "~0*3$"
    },
    {
        value: "Personal Effects",
        lic: "Personal Effects",
        parentLic: "Certificate Of Origin-Non",
        serviceCode: 822,
        description: "~02*3$"
    },
    {
        value: "Information Services",
        lic: "Information Services",
        parentLic: "Information Services",
        serviceCode: 3417,
        description: "~01*1$"
    },
    {
        value: "Mediation",
        lic: "Mediation",
        parentLic: "Mediation",
        serviceCode: 815,
        description: "~0*7$"
    },
    {
        value: "Renew",
        lic: "Renew",
        parentLic: "Membership Services",
        serviceCode: 3407,
        description: "~0*1$"
    },
    {
        value: "Amendment",
        lic: "Amendment",
        parentLic: "Membership Services",
        serviceCode: 840,
        description: "~0*2$"
    },
    {
        value: "New Membership",
        lic: "New Membership",
        parentLic: "Membership Services",
        serviceCode: 3406,
        description: "~02*4$"
    },
    {
        value: "Authenticate Certificate",
        lic: "Authenticate Certificate",
        parentLic: "Signature Of Verification",
        serviceCode: 831,
        description: "~0*8$"
    },
    {
        value: "True Copy",
        lic: "True Copy",
        parentLic: "Signature Of Verification",
        serviceCode: 830,
        description: "~0*9$"
    },
    {
        value: "Verify Signature",
        lic: "Verify Signature",
        parentLic: "Signature Of Verification",
        serviceCode: 829,
        description: "~01*0$"
    }
];
